import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';

export const useFavoritesApi = () => {
  const { getFavoriteExperiences } = useExperienceApi();

  const getFavoriteIds = async (): Promise<number[]> => {
    try {
      const response = await getFavoriteExperiences();

      if (response && typeof response === 'object' && 'data' in response && Array.isArray(response.data)) {
        return response.data.map((item) => item.item_id);
      }

      throw new Error(`Неожиданный формат ответа от API: ${JSON.stringify(response)}`);
    } catch (error) {
      console.error('Ошибка при получении избранных экспириенсов:', error);

      return [];
    }
  };

  return {
    getFavoriteIds,
  };
};
